<div class="info-popover flex flex-col items-start justify-start gap-2.5">
  <h2>¿Para que sirven las carpetas?</h2>
  <p>
    Es muy sencillo, esto sirve para que puedas subir tus documentos en grupos separados y darles una configuración
    diferente a cada grupo de documentos.
  </p>
</div>
